<style scoped>
 /*   .expand-row{
        padding:10px !important;
        width: 100% !important;
    }
    .border ivu-table-body .expand-row .ivu-table-expanded-cell{
        padding: 20px 0px !important;
    }
    .border ivu-table-expanded-cell{
        padding:20px 0px !important;
    }*/
</style>
<template>
    <div>
        <!-- {{rows3}} -->
        <Table  :columns="columns2" :data="data2" class="border"></Table>
        <!-- <button @click="rng">111111</button> -->
    </div>
</template>
<script>
    import axios from 'axios';
    import config from 'config/apiConfig';
    import language from 'api/language'
    export default {
        data(){
            return{
                language:{},
               
                columns2: [
                    {
                        title: language.shouhuokehu,
                        align:'center',
                        minWidth:80,
                        key: 'customerName'
                    },
                    {
                        title: language.cangku,
                        align:'center',
                        minWidth:90,
                        key: 'warehouseName',
                    },
                    {
                        title: language.kunbaohao,
                        align:'center',
                        minWidth:90,
                        key: 'serialCode',
                    },
                    {
                        title: language.pinzhong,
                        align:'center',
                        minWidth:50,
                        key: 'categoryName'
                    },
                    {
                        title: language.paihao,
                        align:'center',
                        minWidth:100,
                        key: 'shopsign'
                    },
                    {
                        title: language.guige,
                        align:'center',
                        minWidth:90,
                        key: 'specification'
                    },
                    {
                        title: language.zhongliang,
                        align:'center',
                        minWidth:40,
                        key: 'quantity'
                    },
                    {
                        title: language.shuliang,
                        align:'center',
                        minWidth:40,
                        key: 'secondQty'
                    },
                    {
                        title: language.mujuanhao,
                        align:'center',
                        minWidth:100,
                        key: 'reelNo'
                    },
                    {
                        title: language.mujuanzhongliang,
                        minWidth:50,
                        align:'center',
                        key: 'rawPrimaryQty'
                    },
                    {
                        title: language.mujuanguige,
                        minWidth:80,
                        align:'center',
                        key: 'rawPieceSpecdesc'
                    },
                    {
                        title: language.bingbaohao,
                        minWidth:100,
                        align:'center',
                        key: 'extCol6'
                    },
                    
                    {
                        title: language.tihuoriqi,
                        minWidth:100,
                        align:'center',
                        key: 'deliveryDate'
                    },
                    {
                        title: language.chukuriqi,
                        align:'center',
                        minWidth:100,
                        key: 'outstockDate'
                    },
                    {
                        title: language.kuwei,
                        align:'center',
                        minWidth:50,
                        key: 'locationName'
                    },
                    {
                        title: language.chukuzhuangtai,
                        align:'center',
                        minWidth:80,
                        key: 'outStatusName'
                    }

                ],
                data2:[],
                row:this.rows3
                //row:rows
           // titles:[
           //      "仓库","原料品种","原料牌号","原料规格","重量","捆包号","内/外版","入库日期","交货期","成品规格","成品重量","成品数量","操作",
           // ]
                //
            }
        },
        props: {
            rows3: Object,
        },

        methods:{
            ow:function(){
                console.log(this.rows3)
            },
            rng(indexs){
                let that=this;
                axios.post(config.queryXSOntOutApplyLine,{
                    "orderNo": that.rows3.orderNo,
                    "flag": that.rows3.flag,

                }).then(function(response){
                     // console.log(response)
                     console.log(1)
                    console.log(that.rows3)
                     
                    that.data2=response.data.resultData
                })
            },
        },
        mounted(){
             // console.log(this)
             this.rng()
             this.language=language
        }

    };
</script>


// WEBPACK FOOTER //
// ladingexpand.vue?e031226a